import React from "react";
import ComplianceSection from "../../components/ComplianceSection/ComplianceSection";

const PhoneCompliance = () => {
  return <ComplianceSection />;
};

export default PhoneCompliance;
